export const replaceHost = data => {
  try {
    const responseDataStr = JSON.stringify(data)
    if (responseDataStr.includes('//img.oichatlife.com')) {
      const modifiedDataStr = responseDataStr.replaceAll('//img.oichatlife.com', '//img.trelokibu.com')
      return JSON.parse(modifiedDataStr)
    }
  } catch (e) {
  }
  return data
}
